import { Injectable } from '@angular/core';
import { Result } from '@rtls/core/models/result.model';
import { Pagination } from '@rtls/core/models/rpc/pagination.model';
import { SearchOperation } from '@rtls/core/models/rpc/search-operation';
import { SearchQuery } from '@rtls/core/models/rpc/search-query';

import { RtlsModels } from '@rtls/core/models/rtls/rtls-models';
import { RtlsServiceDecorator } from '@rtls/core/models/rtls/rtls-service.decorator';
import { RtlsService } from '@rtls/core/models/rtls/rtls-service.model';
import { Tag } from '@rtls/core/models/tag/tag.model';
import { Observable } from 'rxjs';

@Injectable()
export class TagAttachementService extends RtlsServiceDecorator<Tag> {
	constructor(rtlsService: RtlsService<Tag>) {
		super(rtlsService.useModel(RtlsModels.TagAttachment));
	}

	prebuiltSearch(searchTerms: string, pagination: Pagination = Pagination.unlimited()): Observable<Result<Tag>> {
		return super.search(this.generateQuery(searchTerms), pagination);
	}

	generateQuery(searchTerms: string): SearchQuery {
		const deployedQuery = new SearchQuery('currentState.state', SearchOperation.EQUALS, 'DEPLOYED');
		if (searchTerms) {
			return SearchQuery.AND(deployedQuery, new SearchQuery('name', SearchOperation.CONTAINS, searchTerms));
		}
		return deployedQuery;
	}
}
